export default __webpack_public_path__ + "static/media/Hero-Picture 1 - without text.7c6eaee1.jpg";